import type { FC } from 'react';
import React, { useEffect, useContext } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { START_TOUCH } from '@confluence/navdex';
import { ExperienceTrackerContext, HOME_EXPERIENCE } from '@confluence/experience-tracker';

import { useSelectedView } from './useSelectedView';
import { View } from './homeRouteParams';
import { Overview, Recent, Drafts, Starred, Tasks } from './HomeViews';

export const HomeMainContentArea: FC = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const selectedView = useSelectedView();
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'viewed',
				actionSubject: `${selectedView}Screen`,
				source: 'homeScreen',
				attributes: {
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	}, [selectedView, createAnalyticsEvent]);

	switch (selectedView) {
		case View.RECENT:
			return <Recent />;
		case View.STARRED:
			return <Starred />;
		case View.DRAFTS:
			return <Drafts />;
		case View.TASKS:
			/**
			 * We don't want the task home experience to impact Home. This will consider the Home experience as complete
			 * for the purposes of the loading indicator underneath the main navigation bar.
			 */
			experienceTracker.succeed({
				name: HOME_EXPERIENCE,
			});
			return <Tasks />;
		case View.OVERVIEW:
		default:
			return <Overview />;
	}
};
